customerAccountLinks.$inject = ["API_URL", "$rootScope", "$cookies", "$location"];
import 'bootstrap/js/dropdown';
angular.module('calendarApp').directive('customerAccountLinks', customerAccountLinks);

function customerAccountLinks(API_URL, $rootScope, $cookies, $location) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/customer-account-links.html',
    link: function link(scope, elem, attrs) {
      scope.charging = smooth.charging;
    }
  };
}